import { ROUTES_CUSTOMERS } from '@/app/data/route_constants';

const routesIssues = [
  {
    component: () => import('@/app/_customers/subpages/issues/AftercareSubpage.vue'),
    path: '',
    props: true,
    name: ROUTES_CUSTOMERS.ISSUES,
  },
  {
    name: ROUTES_CUSTOMERS.ISSUES_TICKETS,
    path: 'tickets',
    component: () => import('@/app/_customers/subpages/issues/AftercareTicketsSubpage.vue'),
    props: true,
  },
  {
    name: ROUTES_CUSTOMERS.ISSUE_SHOW_TICKET,
    path: ':ticket_id',
    component: () => import('@/app/_customers/subpages/issues/AftercareTicketSubpage.vue'),
    props: true,
  },
];

export default routesIssues;
